module.exports = __webpack_public_path__ + "img/AC_S3_Header.8038e183.jpg";